import React from 'react';
import ContextMenu from 'flow/components/ContextMenu';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import SuggestedTagsButton from 'flow/components/tickets/Input/SuggestedTagsButton';
import { TicketKey } from 'flow/types/EntityKeys';
import MenuItemCopySummary from './MenuItemCopySummary';

interface Props {
    ticketKey: TicketKey;
    summary?: string;
}

const CallSummaryContextMenu = ({ ticketKey, summary }: Props) => {
    const { i18next } = useAppContext();

    return (
        <ContextMenu
            triggerLabel={i18next.t('menu.more_options')}
            className="flex size-7 items-center justify-center bg-transparent! p-0! text-gray-600"
            icon={<Icon iconKey="more_vert" size="1.25rem" />}
            preventOverflow={true}
            skipPortal={true}
        >
            <SuggestedTagsButton
                ticketKey={ticketKey}
                segmentContext="Call summary"
                variant="menuItem"
            />
            <MenuItemCopySummary summary={summary} />
        </ContextMenu>
    );
};

export default CallSummaryContextMenu;
